var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.isEmpty)?_c(_setup.HeadlinedTitleList,{attrs:{"titles":_setup.titles,"title":_vm.title,"additionalContexts":_vm.additionalContexts,"impressionTrackingLabel":_vm.impressionTrackingLabel,"impressionTrackingProperty":_vm.impressionTrackingProperty}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }